/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Happy_Kind_Jay_LurkInputs */

const en_happy_kind_jay_lurk = /** @type {(inputs: Happy_Kind_Jay_LurkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read`)
};

const de_happy_kind_jay_lurk = /** @type {(inputs: Happy_Kind_Jay_LurkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesen`)
};

/**
* | output |
* | --- |
* | "Read" |
*
* @param {Happy_Kind_Jay_LurkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const happy_kind_jay_lurk = /** @type {((inputs?: Happy_Kind_Jay_LurkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Kind_Jay_LurkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_happy_kind_jay_lurk(inputs)
	return de_happy_kind_jay_lurk(inputs)
});